import apiClient from './apiClient';

export interface CreditSubmission {
  id: number;
  submission_number: string;
  status: 'draft' | 'submitted' | 'reviewed' | 'approved' | 'rejected';
  debtor_id: number | null;
  application_type: string;
  credit_system: string;
  debtor_type: 'individual' | 'corporate';
  is_entrepreneur: boolean;
  debtor_profile: string;
  loan_purpose: string;
  requested_amount: number;
  debtor_name: string;
  id_number: string;
  birth_place: string;
  birth_date: string;
  gender: string;
  marital_status: string;
  education: string;
  photo_url: string;
  phone: string;
  mother_maiden_name: string;
  emergency_contact: string;
  bank_relationship: string;
  last_facility: string;
  last_credit_quality: string;
  last_arrears: number;
  slik_document_url: string;
  slik_effective_plafon: number;
  slik_outstanding: number;
  slik_worst_quality: string;
  slik_data_month: string;
  slik_position_date: string;
  address: string;
  village: string;
  district: string;
  city: string;
  latitude: number | null;
  longitude: number | null;
  relations: any[];
  business_documents: any[];
  collateral_info: any;
  collateral_documents: any[];
  collateral_latitude: number | null;
  collateral_longitude: number | null;
  appraisal_data: any;
  credit_history: any[];
  financial_projection: any;
  current_step: number;
  scoring_model_id: number | null;
  created_at: string;
  updated_at: string;
}

export interface CreditSubmissionFilters {
  status?: string;
}

const creditSubmissionApi = {
  getAll: (filters?: CreditSubmissionFilters) => {
    let endpoint = '/credit/submissions';
    if (filters) {
      const params = new URLSearchParams();
      Object.entries(filters).forEach(([key, value]) => {
        if (value) params.append(key, value);
      });
      const queryString = params.toString();
      if (queryString) endpoint += `?${queryString}`;
    }
    return apiClient.get<CreditSubmission[]>(endpoint);
  },

  getById: (id: number) => {
    return apiClient.get<CreditSubmission>(`/credit/submissions/${id}`);
  },

  create: (data: Partial<CreditSubmission>) => {
    return apiClient.post<CreditSubmission>('/credit/submissions', data);
  },

  update: (id: number, data: Partial<CreditSubmission>) => {
    return apiClient.put<CreditSubmission>(`/credit/submissions/${id}`, data);
  },

  delete: (id: number) => {
    return apiClient.delete(`/credit/submissions/${id}`);
  },
};

export default creditSubmissionApi;
